import { render, staticRenderFns } from "./InteresSuperior.vue?vue&type=template&id=4ca98320"
import script from "./InteresSuperior.vue?vue&type=script&lang=js"
export * from "./InteresSuperior.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports